import { Card, Col, message, Row, Skeleton } from "antd";
import { DashboardApiService } from "features/dashboard/api/dashboard-api.service";
import CardSkeletonView from "features/dashboard/components/Skeleton/skeletonView";
import { useGetDashBoardList } from "features/dashboard/use-cases/get-dashboardUserBehaviour";
import { cardColors, monthNameToNumber } from "features/facilities";
import { useEffect, useState } from "react";

import { BookingtopFacilites } from "./Bookings-revenue";
import { BookingViewType } from "./bookingView-type";
import { FinincalBookingData } from "./finincal-booking";
import { MonthlyRevenue } from "./MonthlyRevenue";
import { PaymentMethod } from "./payment-method";
import { PaymentMethodTypeView } from "./payment-methodtype";
import { RevenuePerSportsGraph } from "./Revenuepersports";
import { TransctionData } from "./tranasction-view";

export const FininacalBookingGraphView = ({
  selectedYear,
  selectedMonth,
  dateRange,
  facilityId,
}: any) => {
  // Convert month short name to number or null if 'All' is selected
  const [state, setState] = useState(null);
  const monthNumber =
    selectedMonth === "All" || selectedMonth === null
      ? null
      : typeof selectedMonth === "string"
      ? monthNameToNumber(selectedMonth)
      : null;

  // Determine from/to dates based on dateRange if valid
  // If no valid dateRange or "All" selected, do NOT send FromDate/EndDate
  const from =
    selectedMonth !== "All" &&
    selectedMonth !== null &&
    dateRange?.[0]?.isValid()
      ? dateRange[0].format("YYYY-MM-DD")
      : null;

  const to =
    selectedMonth !== "All" &&
    selectedMonth !== null &&
    dateRange?.[1]?.isValid()
      ? dateRange[1].format("YYYY-MM-DD")
      : null;

  const GetDashboardData = (flag: string) => {
    const params: any = {
      Type: "Financial",
      Month: monthNumber,
      Year: selectedYear,
      Flag: flag,
      facilityId: facilityId,
    };

    if (from && to) {
      params.FromDate = from;
      params.EndDate = to;
    }

    return useGetDashBoardList(params);
  };

  // Fetch all data
  const { data: finincalCard, isFetching: finincalData } =
    GetDashboardData("KPI");
  const { data: PaymentMethodData, isFetching: PaymentMethodisLoading } =
    GetDashboardData("PaymentMethod");
  const {
    data: PaymentMethodTypeData,
    isFetching: paymentmethodtypeIsLoading,
  } = GetDashboardData("PaymentMethodType");
  const { data: Bookingfacilites, isFetching: bookingfacilitesIsloading } =
    GetDashboardData("TopFacilities");
  // const { data: BookingRevenueSportdata, isFetching: bookingRevenueIsloading } =
  //   GetDashboardData('BookingRevenueSport');
  const { data: MonthlyRevenueData, isFetching: MonthlyRevenueisLoading } =
    GetDashboardData("MonthlyRevenue");
  const { data: BookingData, isFetching: bookingdataIsFetching } =
    GetDashboardData("Booking");
  const { data: BookingDatatype, isFetching: bookingdataIsFetchingtype } =
    GetDashboardData("BookingType");
  const { data: RevenuePerSports, isFetching: RevenuePerSportsGraphFetching } =
    GetDashboardData("BookingRevenueSport");
  const orderedNames = [
    "Total Revenue",
    "Total Booking",
    "Overall Wallet Amount",
  ];
  const sortedItems = orderedNames
    .map((name) => finincalCard?.items?.find((item: any) => item.Name === name))
    .filter(Boolean); // remove undefined if any item is missing
  const Initial = async () => {
    try {
      setState(null);
      const params: any = {
        Flag: "KPI",
        Year: selectedYear,
        facilityId,
      };

      if (monthNumber !== null && !from && !to) {
        params.Month = monthNumber;
      }

      if (from && to) {
        params.FromDate = from;
        params.EndDate = to;
      }

      const apiRes = await DashboardApiService().getDashBoardTranasition(
        params
      );
      setState(apiRes);
    } catch (error: any) {
      message.error(error?.message || "Something went wrong");
    }
  };

  useEffect(() => {
    Initial();
  }, [monthNumber, dateRange, selectedYear, facilityId]);
  
return (
    <>
      <Row
        gutter={[16, 16]}
        style={{ marginBottom: 24 }}
        className="card_row_main"
      >
        {finincalData
          ? Array.from({ length: 3 }).map((_, index) => (
              <CardSkeletonView key={index} />
            ))
          : sortedItems.map((item: any) => (
              <Col span={6} key={item.Name}>
                <Card
                  style={{ backgroundColor: cardColors[item.Name] || "#fff" }}
                >
                  <div style={{ textAlign: "center" }}>
                    <span style={{ fontSize: 16, color: "#fff" }}>
                      {item.Name}
                    </span>
                    <h4 style={{ fontSize: 28, margin: 0, color: "#fff" }}>
                      {item.Value ? (
                        item.Name === "Total Booking" ? (
                          <>
                            {item.Value}
                            {/* <span style={{ fontSize: '16px' }}>KWD</span> */}
                          </>
                        ) : (
                          <>
                            {item.Value}
                            <span style={{ fontSize: "16px" }}>KWD</span>
                          </>
                        )
                      ) : (
                        <>
                          {item.Value}
                          <span style={{ fontSize: "16px" }}>KWD</span>
                        </>
                      )}
                    </h4>
                  </div>
                </Card>
              </Col>
            ))}
      </Row>

      <Row gutter={[16, 16]} className="graph_row">
        <Col span={12}>
          {MonthlyRevenueisLoading ? (
            <Skeleton active paragraph={{ rows: 6 }} />
          ) : (
            <MonthlyRevenue data={MonthlyRevenueData} />
          )}
        </Col>

        <Col span={12}>
          {bookingdataIsFetching ? (
            <Skeleton active paragraph={{ rows: 6 }} />
          ) : (
            <FinincalBookingData data={BookingData} />
          )}
        </Col>
        <Col span={12}>
          {bookingdataIsFetchingtype ? (
            <Skeleton active paragraph={{ rows: 6 }} />
          ) : (
            <BookingViewType data={BookingDatatype} />
          )}
        </Col>
        <Col span={12}>
          {bookingfacilitesIsloading ? (
            <Skeleton active paragraph={{ rows: 6 }} />
          ) : (
            <BookingtopFacilites data={Bookingfacilites} />
          )}
        </Col>
        <Col span={24}>
          {RevenuePerSportsGraphFetching ? (
            <Skeleton active paragraph={{ rows: 6 }} />
          ) : (
            <RevenuePerSportsGraph data={RevenuePerSports} />
          )}
        </Col>
        {/* <Col span={12}>
          {bookingRevenueIsloading ? (
            <Skeleton active paragraph={{ rows: 6 }} />
          ) : (
            <BookingRevenuePerSport data={BookingRevenueSportdata} />
          )}
        </Col> */}
        <Col span={24}>
          {paymentmethodtypeIsLoading ? (
            <Skeleton active paragraph={{ rows: 6 }} />
          ) : (
            <TransctionData
              data={state}
              monthNumber={monthNumber}
              selectedYear={selectedYear}
            />
          )}
        </Col>

        <Col span={12}>
          {PaymentMethodisLoading ? (
            <Skeleton active paragraph={{ rows: 6 }} />
          ) : (
            <PaymentMethod data={PaymentMethodData} />
          )}
        </Col>

        <Col span={12}>
          {paymentmethodtypeIsLoading ? (
            <Skeleton active paragraph={{ rows: 6 }} />
          ) : (
            <PaymentMethodTypeView data={PaymentMethodTypeData} />
          )}
        </Col>
      </Row>
    </>
  );
};
